import React from 'react';
import { Row } from 'antd';

import FormInput from 'components/FormInput';

const TabPaymentClientInvoice = () => (
  <Row>
    <FormInput col xs={24} lg={12} name="externalreference" rules={[{ required: true }]}/>
  </Row>
);

export default TabPaymentClientInvoice;
